// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "96678") return "static/css/" + chunkId + ".dae66e64.css";
  // return url for filenames based on template
  return "static/css/async/" + ({"25505": "editor","85312": "WorkflowEditor",}[chunkId] || chunkId) + "." + {"25505": "ac94b410","40009": "71bf4dc3","85312": "693fa2e1",}[chunkId] + ".css"
}